import React from "react";

const InformationTab = ({information}) => {
    return (
        <div className="tab_text">
            <table className="table">
                <tbody>
                    {information.map((item, i, k, v) => (
                        <tr key={i}>
                            <td key={k}>{item.key}</td>
                            <td key={v}>{item.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
export default InformationTab;
